// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30E_i","badges":"styles_badges__1Zdvf"};